import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "layout",
  "use": "layout-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"layout\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 341.333333V256a128 128 0 0 0-128-128H256a128 128 0 0 0-128 128v85.333333zM128 426.666667v341.333333a128 128 0 0 0 128 128h213.333333V426.666667zM554.666667 426.666667v469.333333h213.333333a128 128 0 0 0 128-128v-341.333333z\" p-id=\"1485\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol